import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Prompt } from "react-router-dom";
import {
  Box,
  Card,
  TextField,
  Typography,
  CardContent,
  Grid,
  makeStyles,
  Theme,
  Switch,
  Divider,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";

import TabHeader from "src/components/TabHeader/TabHeader";
import { OthersRoute } from "../../others.routes";
import { columns } from "./components/columns";
import { searchData } from "src/app-redux/common-actions";
import * as Yup from "yup";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { useAppSelector } from "src/app-redux/hooks";
import {
  createRFIDTag,
  deleteRFIDTag,
  updateRFIDTag,
} from "src/app-redux/customs/actions/customsActions";
import { loader } from "src/app-redux/customs/customsSlice";
import { filteryByArr } from "src/common/utils/app.dropdowns";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import CommonLoader from "src/components/Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  button: {
    margin: theme.spacing(1),
  },
  hideDatesGrid: {
    display: "none",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
}));

interface Props {}

export function RFIDPage({}: Props): React.ReactElement {
  const classes = useStyles();
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [moduleName, setmoduleName] = useState<any>(OthersRoute.title);
  const [vehicleRecord, setvehicleRecord] = React.useState<GridRowModel[]>([]);
  const [pageHeading, setpageHeading] = useState<any>("RFID Tags");
  const [loader2, setLoader] = useState<any>(false);
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [vehicleRegNumberArr, setvehicleRegNumberArr] = React.useState<any[]>([]);
  const [vehicleNumber, setVehicleNumber] = useState<any>("");
  const [isEditMode, setisEditMode] = React.useState<boolean>(false);
  const loading = useAppSelector(loader);
  let vehicleRegArr: any[] = [];
  const [vehicleNumberLength, setVehicleNumberLength] = useState<number>(0);
  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);

  useEffect(() => {
    formik.setFieldValue("filterBy", "today");
    setLoader(true);
    handleSearch();
  }, []);

  const { height } = UseWindowDimensions();
  let dppr = 10;
  if (height > 700 && height < 900) {
    dppr = 15;
  } else if (height > 900) {
    dppr = 25;
  } else {
    dppr = 10;
  }
  const validationSchema = Yup.object().shape({
    vehicleNumber: Yup.string().required("This field is required"),
    rfidTagNumber: Yup.string()
      .max(18, "Maximum 18  characters allowed")
      .required("This field is required"),
  });
  const formik = useFormik({
    initialValues: {
      id: 0,
      vehicleNumber: "",
      gatePassId: 0,
      rfidTagNumber: "",

      filterBy: "today",
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      InProgressVehiclesDataOnly: true,
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      setLoader(true);
      // Add API here
      const request = {
        id: values.id,
        gatePassId: values.gatePassId,
        vehicleNumber: values.vehicleNumber,
        rfidTagNumber: values.rfidTagNumber,
      };
      const res: any = !isEditMode
        ? await dispatch(createRFIDTag(request))
        : await dispatch(updateRFIDTag(request));

      if (res) {
        handleSearch();
        setisEditMode(false);
        actions.setSubmitting(false);
        actions.resetForm();
        setIsDirty(false);
      }
      setLoader(false);
    },
  });
  const { values, setValues } = formik;

  /* AXIOS Calls */
  const getVehicleByRegistrationNo = async (queryString: string) => {
    let results: any = [];
    results = await fetchWrapper.get(
      `search-vehicles-by-vehicle-registration-number/${queryString}`
    );
    if (results.isSuccess) {
      setvehicleRegNumberArr(results.value);
      vehicleRegArr = results.value;
    }
    return;
  };
  /*./AXIOS Calls */

  const handleSearch = async () => {
    const { filterBy, startDate, endDate, InProgressVehiclesDataOnly } = values;
    const body = {
      filterBy: filterBy || null,
      startDate: startDate || null,
      endDate: endDate || null,
      InProgressVehiclesDataOnly: InProgressVehiclesDataOnly,
    };
    setvehicleRecord([]);
    setLoader(true);
    // Add API here
    const arr = [
      {
        id: 1,
        serialNo: "1",
        rfidTagNumber: "1",
        vehicleNumber: "MZ-123",
        gatePassId: "1",
      },
      {
        id: 2,
        serialNo: "2",
        rfidTagNumber: "2",
        vehicleNumber: "MZ-234",
        gatePassId: "2",
      },
      {
        id: 3,
        serialNo: "3",
        rfidTagNumber: "3",
        vehicleNumber: "3",
        gatePassId: "3",
      },
      {
        id: 4,
        serialNo: "4",
        rfidTagNumber: "4",
        vehicleNumber: "4",
        gatePassId: "4",
      },
      {
        id: 5,
        serialNo: "5",
        rfidTagNumber: "5",
        vehicleNumber: "5",
        gatePassId: "5",
      },
    ];
    setvehicleRecord(arr);
    try {
      const results: any = await dispatch(searchData("/get-all-rfid-tags", JSON.stringify(body)));
      if (results) {
        const transformedData = results.map((data: any, index: any) => {
          return data;
        });
        setvehicleRecord(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };
  const resetSearch = () => {
    setValues(formik.initialValues);
    setIsDirty(false);
  };
  const resetGrid = () => {
    setvehicleRecord([]);
  };
  const filterByAction = (data: any) => {
    if (data && data.value) {
      const td = new Date();
      const today = moment(td.setDate(td.getDate())).format("YYYY-MM-DD");
      const yesterday = moment(td.setDate(td.getDate() - 1)).format("YYYY-MM-DD");
      const lastWeek = moment(td.setDate(td.getDate() - 7)).format("YYYY-MM-DD");
      const lastMonth = moment(td.setDate(td.getDate() - 30)).format("YYYY-MM-DD");

      if (data.value === "today") {
        formik.setFieldValue("filterBy", "today");
        formik.setFieldValue("startDate", today);
      }
      if (data.value === "yesterday") {
        formik.setFieldValue("filterBy", "yesterday");
        formik.setFieldValue("startDate", yesterday);
      }

      if (data.value === "lastWeek") formik.setFieldValue("startDate", lastWeek);
      if (data.value === "lastMonth") formik.setFieldValue("startDate", lastMonth);
      if (
        data.value === "today" ||
        data.value === "yesterday" ||
        data.value === "lastWeek" ||
        data.value === "lastMonth"
      ) {
        setIsCustomDate(false);
      }
      if (data.value === "custom") {
        setIsCustomDate(true);
        formik.setFieldValue("startDate", today);
        formik.setFieldValue("endDate", today);
      }
    }
  };

  const handleUpdateClick = async (params: any) => {
    await getVehicleByRegistrationNo(params.vehicleNumber);
    setisEditMode(true);

    const vehicle = vehicleRegNumberArr.length
      ? vehicleRegNumberArr.find((st: any) => st.registrationNumber === params.vehicleNumber)
      : vehicleRegArr.find((st: any) => st.registrationNumber === params.vehicleNumber);
    formik.setFieldValue("vehicleNumber", params.vehicleNumber);

    formik.setFieldValue("id", params.id);
    formik.setFieldValue("gatePassId", params.gatePassId);
    formik.setFieldValue("rfidTagNumber", params.rfidTagNumber ?? "");
  };
  const handleDelete = async (id: any) => {
    if (confirm("Are you sure you want to delete?")) {
      const res: any = await dispatch(deleteRFIDTag(id));
      if (res.payload) {
        handleSearch();
        formik.resetForm();
      }
    }
  };
  useEffect(() => {
    if (vehicleRecord.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "actionButtons"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <>
                    <NewCommonButton
                      onClick={() => {
                        setIsDirty(true);
                        handleUpdateClick(row.original);
                      }}
                      icon={<EditIcon />}
                      isEdit={true}
                    >
                      Edit
                    </NewCommonButton>
                    <NewCommonButton
                      onClick={() => {
                        handleDelete(row.original?.id);
                      }}
                      icon={<DeleteIcon />}
                    >
                      Delete
                    </NewCommonButton>
                  </>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [vehicleRecord]);

  // Show prompt if the form is fully or partially filled and user wants to navigate away
  const [isDirty, setIsDirty] = React.useState<boolean>(false);
  useEffect(() => {
    // If prompt, when reloading or closing the tab
    window.onbeforeunload = function (e: Event) {
      if (isDirty) {
        e.preventDefault();
        return "Changes you made may not be saved.";
      }
    };
  }, [isDirty]);

  function handleChange(e: any) {
    // Textfield ==>> e.target.value
    // Checkbox / Switch ==>> e.target.checked !== e.target._wrapperState.initialChecked
    formik.handleChange(e);
    e.target.value || JSON.stringify(formik.values) !== JSON.stringify(formik.initialValues)
      ? setIsDirty(true)
      : setIsDirty(false);
  }

  return (
    <div>
      {/* If prompt, when navigating to another page inside the app */}
      <Prompt when={isDirty} message="Changes you made may not be saved." />
      <TabHeader module={moduleName} heading={pageHeading} link={OthersRoute.path} />
      <Backdrop className={classes.backdrop} open={loader2 || loading}>
        <CommonLoader />
      </Backdrop>
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={9}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}> {pageHeading} </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={3}>
              <Box textAlign="right" mt={1} mb={1}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
                  Reset
                </CommonButton>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  onClick={() => formik.submitForm()}
                >
                  {isEditMode ? "Update" : "Save"}
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
          <Box style={{ marginBottom: "30px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row">
              {/* Vehicle Number */}
              <Grid item xs={12} md={4}>
                <Box>
                  <CommonAutoCompleteField
                    cssClassName="customTextField"
                    label="Vehicle Number"
                    placeholder="Select Vehicle Number"
                    name="vehicleNumber"
                    optionsType={vehicleRegNumberArr}
                    getOptionLabel={(option) => option.registrationNumber}
                    required
                    value={
                      vehicleRegNumberArr.find(
                        (st: any) => st.registrationNumber === formik.values.vehicleNumber
                      ) || null
                    }
                    onChange={(option: any) => {
                      if (option && option.vehicleNumber !== "" && option.vehicleId !== 0) {
                        formik.setFieldValue("gatePassId", option.gatePassId);
                        formik.setFieldValue("vehicleNumber", option.registrationNumber);
                        handleChange({ target: { value: option.vehicleId } });
                      } else {
                        formik.setFieldValue("vehicleNumber", "");
                        formik.setFieldValue("gatePassId", "");
                        handleChange({ target: { value: null } });
                      }
                    }}
                    onKeyUp={(e: any) => {
                      setVehicleNumberLength(e.target.value.length);
                      setVehicleNumber(e.target.value);

                      if (e.target.value.length == 2 && vehicleNumberLength < 2) {
                        getVehicleByRegistrationNo(e.target.value);
                        return;
                      }
                    }}
                    onKeyDownCapture={(e: any) => {
                      if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
                      else handleChange(e);
                    }}
                    onPaste={(e: any) => {
                      if (/[^A-Za-z0-9\d]/.test(e.clipboardData.getData("text"))) {
                        e.preventDefault();
                        return;
                      }

                      if (e.clipboardData.getData("text").length >= 2)
                        getVehicleByRegistrationNo(e.clipboardData.getData("text"));
                    }}
                    error={formik.touched.vehicleNumber && Boolean(formik.errors.vehicleNumber)}
                    helperText={formik.touched.vehicleNumber && formik.errors.vehicleNumber}
                  />
                </Box>
              </Grid>
              {/* RFID Tag # */}
              <Grid item xs={12} md={4}>
                <Box>
                  <TextField
                    className="customTextField"
                    size="small"
                    fullWidth
                    variant="outlined"
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="RFID Tag Number"
                    name="rfidTagNumber"
                    placeholder="Enter RFID Tag Number"
                    disabled={false}
                    value={formik.values.rfidTagNumber}
                    onChange={handleChange}
                    error={formik.touched.rfidTagNumber && Boolean(formik.errors.rfidTagNumber)}
                    helperText={formik.touched.rfidTagNumber && formik.errors.rfidTagNumber}
                  />
                </Box>
              </Grid>
            </Grid>
          </>
          <Box style={{ marginTop: "30px", marginBottom: "30px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row">
              <Grid item xs={12} md={2}>
                <CommonAutoCompleteField
                  cssClassName="customTextField"
                  error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
                  helperText={formik.touched.filterBy && formik.errors.filterBy}
                  label="Filter By"
                  placeholder="Filter By"
                  name="filterBy"
                  optionsType={filteryByArr}
                  getOptionLabel={(option: any) => option.label || null}
                  onChange={(row: any) => {
                    row ? setValues({ ...values, filterBy: row.value || "" }) : "";
                    if (row === null) {
                      formik.setFieldValue("filterBy", null);
                    }
                    filterByAction(row);
                  }}
                  value={
                    filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""
                  }
                />
              </Grid>
              <Grid item xs={12} md={2} className={!isCustomDate ? classes.hideDatesGrid : ""}>
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"Start Date"}
                  type={"date"}
                  name={"startDate"}
                  datePickerRef={startDatePickerRef}
                  value={formik.values.startDate}
                  onChange={formik.handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12} md={2} className={!isCustomDate ? classes.hideDatesGrid : ""}>
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"End Date"}
                  type={"date"}
                  name={"endDate"}
                  datePickerRef={endDatePickerRef}
                  value={formik.values.endDate}
                  onChange={formik.handleChange}
                  minDate={formik.values.startDate}
                  required
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={Boolean(formik.values.InProgressVehiclesDataOnly)}
                      onChange={formik.handleChange}
                      name="InProgressVehiclesDataOnly"
                      color="primary"
                    />
                  }
                  label="In Progress Vehicles"
                />
              </Grid>
              <Grid item xs={12} md={3} direction="row">
                <Box textAlign="right" mt={1} mb={1}>
                  <CommonButton cssClass="customSubmitBtn" onClick={() => resetGrid()}>
                    Reset
                  </CommonButton>
                  <CommonButton cssClass="customSubmitBtn" isGreen onClick={handleSearch}>
                    Search
                  </CommonButton>
                </Box>
              </Grid>
            </Grid>
          </>
          <div className="">
            <CommonMaterialGrid
              rows={vehicleRecord}
              columns={displayColumns}
              defaultPerPageRecord={15}
              height={550}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
